// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CeFz","col":"styles_col__6zGFk"};